import "dayjs/locale/es";
import "dayjs/locale/en";
import "dayjs/locale/pt";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import minMax from "dayjs/plugin/minMax";

import type Dayjs from "dayjs";

dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(tz);
dayjs.extend(minMax);

export { dayjs };
export type { Dayjs };
